import { useState } from "react";
export var nextSortState = function (prev, columnId) {
    if (prev.column === columnId) {
        return {
            column: columnId,
            direction: prev.direction === "ascending" ? "descending" : "ascending",
        };
    }
    return { column: columnId, direction: "ascending" };
};
export var toSortByParam = function (sort) {
    if (!sort.column) {
        return undefined;
    }
    return [
        sort.direction === "descending"
            ? "".concat(sort.column, "/sort.descending")
            : sort.column,
    ];
};
export var useTableSort = function () {
    var _a = useState({ direction: "ascending" }), sort = _a[0], setSort = _a[1];
    var handleHeaderClick = function (columnId) {
        return setSort(function (prev) { return nextSortState(prev, columnId); });
    };
    return { sort: sort, handleHeaderClick: handleHeaderClick };
};
